import React from "react";

export const getContentAsReactElement = (
  content: string | React.ReactElement
): React.ReactElement => {
  return typeof content === "string" ? <span>{content}</span> : content;
};
